import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "work", "pause", "overtime" ]
  static values = {
    work: Number,
    pause: Number,
    overtime: Number,
    status: String
  }

  connect() {
    this.timer = setInterval(() => { this.tick() }, 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    switch (this.statusValue) {
      case "work_start":
      case "pause_end":
        this.workValue += 1
        this.updateDisplay(this.workTarget, this.workValue)
        break
      case "pause_start":
        this.pauseValue += 1
        this.updateDisplay(this.pauseTarget, this.pauseValue)
        break
      case "overtime_start":
        this.overtimeValue += 1
        this.updateDisplay(this.overtimeTarget, this.overtimeValue)
        break
    }
  }

  updateDisplay(target, totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, "0")
    const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, "0")
    const seconds = (totalSeconds % 60).toString().padStart(2, "0")

    target.textContent = `${hours}:${minutes}:${seconds}`
  }
}
